import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { LogoComponent } from '../../navigation/navbar/logo/logo.component';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [LogoComponent, CommonModule],
})
export class BreadcrumbComponent implements OnChanges {
  @Input() useCustomTitle: boolean = false;
  @Input() station?: string = '';
  @Input() path?: string = '';
  @Input() title: string = '';
  @Input() filter?: string;

  patientName: string = '';
  patientDetails: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['title']) {
      this.splitTitle();
    }
  }

  private splitTitle(): void {
    if (this.title) {
      const firstCommaIndex = this.title.indexOf(',');
      if (firstCommaIndex !== -1) {
        const secondCommaIndex = this.title.indexOf(',', firstCommaIndex + 1);
        if (secondCommaIndex !== -1) {
          this.patientName = this.title.substring(0, secondCommaIndex + 1);
          this.patientDetails = this.title.substring(secondCommaIndex + 1);
        } else {
          this.patientName = this.title;
          this.patientDetails = '';
        }
      } else {
        this.patientName = this.title;
        this.patientDetails = '';
      }
    }
  }
}
